import { Component, OnInit } from '@angular/core';
import { BaseDetailComponent, SharedModule } from 'app/shared/shared.module';
import { Person } from 'app/core/model/entity-model';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    standalone: true,
    imports: [DevExtremeModule, SharedModule],
})
export class DetailComponent extends BaseDetailComponent implements OnInit {
    person: Person;
    key: any;
    genders: any[];
    relationships: any[];
    personStatuses: any;
    states: any[];
    maritalStatus: any[];
    joinedOptions: any[];
    jobCodes: any;
    titles: any;
    phoneOptions = {};
    readOnly = true;
    schools: any;

    async ngOnInit() {
        this.relationships = await this.uow.getRelationships();
        if (this.appInfo.graafschap) {
            this.readOnly = !this.auth.hasRole('Administrator') && !this.auth.hasRole('PeopleAdmin');
            this.phoneOptions = { mask: '+1 (X99) 999-9999', maskRules: { X: /[02-9]?/ } };
        }

        this.genders = [
            { value: 'M', name: 'Male' },
            { value: 'F', name: 'Female' },
        ];
        this.personStatuses = await this.uow.getPersonStatuses();
        this.states = await this.uow.getStates();
        this.maritalStatus = await this.uow.getMaritalStatus();
        this.jobCodes = await this.uow.getJobCodes();
        this.joinedOptions = await this.uow.getJoinCodes();
        this.titles = await this.uow.getTitles();
        this.schools = this.uow.lookups.schools;

        this.key = this.route.snapshot.params['id'];
        if (this.key !== 'new') {
            this.person = await this.uow.people.byId(this.key, 'family.members');
        } else {
            const familyId = this.route.snapshot.queryParams['familyId'];
            await this.uow.families.byId(familyId, 'members');
            this.person = this.uow.people.createEntity({ familyId });
        }
        this.entity = this.person;
    }

    async beforeSave() {
        const result = this.validate();
        if (result && this.person.family) this.person.family.updateName();
        return Promise.resolve(result);
    }

    async afterSave() {
        this.navigateOnSaveNew(this.person.id.toString());
    }
}
